export type Adjustment =
  | 'Increase'
  | 'Decrease'
  | 'Softer'
  | 'Stiffer'
  | 'Higher'
  | 'Lower'
  | 'More'
  | 'Less'
  | 'More Negative'
  | 'More Positive'
  | 'Less Positive'
  | 'Less Negative'
  | 'Pos / Neg'
  | 'Soften'
  | 'Stiffen'
  | null;
export type Condition =
  | 'Loose on Entry'
  | 'Tight on Entry'
  | 'Loose in Center'
  | 'Tight in Center'
  | 'Loose on Exit'
  | 'Tight on Exit'
  | 'Loose Overall'
  | 'Tight Overall';
export interface SetupItem {
  name: string;
  adjustments: Record<Condition, Adjustment>;
}
export interface SetupCategory {
  category: string;
  items: SetupItem[];
}
export const SETUP_MATRIX: SetupCategory[] = [
  {
    category: 'Front',
    items: [
      {
        name: 'Nose Weight',
        adjustments: {
          'Loose on Entry': 'Increase',
          'Tight on Entry': 'Decrease',
          'Loose in Center': 'Increase',
          'Tight in Center': 'Decrease',
          'Loose on Exit': 'Increase',
          'Tight on Exit': 'Decrease',
          'Loose Overall': 'Increase',
          'Tight Overall': 'Decrease'
        }
      },
      {
        name: 'Cross Weight',
        adjustments: {
          'Loose on Entry': 'Increase',
          'Tight on Entry': 'Decrease',
          'Loose in Center': 'Increase',
          'Tight in Center': 'Decrease',
          'Loose on Exit': 'Increase',
          'Tight on Exit': 'Decrease',
          'Loose Overall': 'Increase',
          'Tight Overall': 'Decrease'
        }
      },
      {
        name: 'Front Brake Bias',
        adjustments: {
          'Loose on Entry': 'Increase',
          'Tight on Entry': 'Decrease',
          'Loose in Center': 'Increase',
          'Tight in Center': 'Decrease',
          'Loose on Exit': null,
          'Tight on Exit': null,
          'Loose Overall': null,
          'Tight Overall': null
        }
      },
      {
        name: 'Front ARB: Preload',
        adjustments: {
          'Loose on Entry': 'More Negative',
          'Tight on Entry': 'More Positive',
          'Loose in Center': 'More Negative',
          'Tight in Center': 'More Positive',
          'Loose on Exit': 'Pos / Neg',
          'Tight on Exit': null,
          'Loose Overall': null,
          'Tight Overall': null
        }
      },
      {
        name: 'Front ARB: Diameter',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': null,
          'Tight on Exit': null,
          'Loose Overall': 'Increase',
          'Tight Overall': 'Decrease'
        }
      },
      {
        name: 'Front ARB: Arm',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': null,
          'Tight on Exit': null,
          'Loose Overall': 'Stiffen',
          'Tight Overall': 'Soften'
        }
      }
    ]
  },
  {
    category: 'Left Front',
    items: [
      {
        name: 'Tire Pressure',
        adjustments: {
          'Loose on Entry': 'Decrease',
          'Tight on Entry': 'Increase',
          'Loose in Center': 'Decrease',
          'Tight in Center': 'Increase',
          'Loose on Exit': 'Decrease',
          'Tight on Exit': 'Increase',
          'Loose Overall': 'Decrease',
          'Tight Overall': 'Increase'
        }
      },
      {
        name: 'Toe-in',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': 'Decrease',
          'Tight on Exit': 'Increase',
          'Loose Overall': null,
          'Tight Overall': null
        }
      },
      {
        name: 'Shock Collar Offset',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': null,
          'Tight on Exit': null,
          'Loose Overall': 'More Negative',
          'Tight Overall': 'More Positive'
        }
      },
      {
        name: 'Spring Rate',
        adjustments: {
          'Loose on Entry': 'Decrease',
          'Tight on Entry': 'Increase',
          'Loose in Center': 'Softer',
          'Tight in Center': 'Stiffer',
          'Loose on Exit': 'Decrease',
          'Tight on Exit': 'Increase',
          'Loose Overall': 'Decrease',
          'Tight Overall': 'Increase'
        }
      },
      {
        name: 'Compression',
        adjustments: {
          'Loose on Entry': 'Decrease',
          'Tight on Entry': 'Increase',
          'Loose in Center': 'Decrease',
          'Tight in Center': 'Increase',
          'Loose on Exit': null,
          'Tight on Exit': null,
          'Loose Overall': null,
          'Tight Overall': null
        }
      },
      {
        name: 'Rebound',
        adjustments: {
          'Loose on Entry': 'Increase',
          'Tight on Entry': 'Decrease',
          'Loose in Center': 'Increase',
          'Tight in Center': 'Decrease',
          'Loose on Exit': null,
          'Tight on Exit': null,
          'Loose Overall': 'Decrease',
          'Tight Overall': 'Increase'
        }
      },
      {
        name: 'Camber',
        adjustments: {
          'Loose on Entry': 'Less Positive',
          'Tight on Entry': 'More Positive',
          'Loose in Center': 'Less Positive',
          'Tight in Center': 'More Positive',
          'Loose on Exit': 'Less Positive',
          'Tight on Exit': 'More Positive',
          'Loose Overall': 'Less Positive',
          'Tight Overall': 'More Positive'
        }
      }
    ]
  },
  {
    category: 'Right Front',
    items: [
      {
        name: 'Tire Pressure',
        adjustments: {
          'Loose on Entry': 'Increase',
          'Tight on Entry': 'Decrease',
          'Loose in Center': 'Increase',
          'Tight in Center': 'Decrease',
          'Loose on Exit': 'Increase',
          'Tight on Exit': 'Decrease',
          'Loose Overall': 'Increase',
          'Tight Overall': 'Decrease'
        }
      },
      {
        name: 'Toe-in',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': 'Increase',
          'Tight on Exit': 'Decrease',
          'Loose Overall': null,
          'Tight Overall': null
        }
      },
      {
        name: 'Shock Collar Offset',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': null,
          'Tight on Exit': null,
          'Loose Overall': 'More Positive',
          'Tight Overall': 'More Negative'
        }
      },
      {
        name: 'Spring Rate',
        adjustments: {
          'Loose on Entry': 'Increase',
          'Tight on Entry': 'Decrease',
          'Loose in Center': 'Increase',
          'Tight in Center': 'Decrease',
          'Loose on Exit': 'Increase',
          'Tight on Exit': 'Decrease',
          'Loose Overall': 'Increase',
          'Tight Overall': 'Decrease'
        }
      },
      {
        name: 'Compression',
        adjustments: {
          'Loose on Entry': 'Increase',
          'Tight on Entry': 'Decrease',
          'Loose in Center': 'Increase',
          'Tight in Center': 'Decrease',
          'Loose on Exit': null,
          'Tight on Exit': null,
          'Loose Overall': null,
          'Tight Overall': null
        }
      },
      {
        name: 'Rebound',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': 'Decrease',
          'Tight on Exit': 'Increase',
          'Loose Overall': null,
          'Tight Overall': null
        }
      },
      {
        name: 'Camber',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': 'Less Negative',
          'Tight on Exit': 'More Negative',
          'Loose Overall': 'Less Negative',
          'Tight Overall': 'More Negative'
        }
      }
    ]
  },
  {
    category: 'Left Rear',
    items: [
      {
        name: 'Tire Pressure',
        adjustments: {
          'Loose on Entry': 'Increase',
          'Tight on Entry': 'Decrease',
          'Loose in Center': 'Increase',
          'Tight in Center': 'Decrease',
          'Loose on Exit': 'Increase',
          'Tight on Exit': 'Decrease',
          'Loose Overall': 'Increase',
          'Tight Overall': 'Decrease'
        }
      },
      {
        name: 'Shock Collar Offset',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': null,
          'Tight on Exit': null,
          'Loose Overall': 'More Positive',
          'Tight Overall': 'More Negative'
        }
      },
      {
        name: 'Spring Rate',
        adjustments: {
          'Loose on Entry': 'Increase',
          'Tight on Entry': 'Decrease',
          'Loose in Center': 'Higher',
          'Tight in Center': 'Lower',
          'Loose on Exit': 'Increase',
          'Tight on Exit': 'Decrease',
          'Loose Overall': 'Increase',
          'Tight Overall': 'Decrease'
        }
      },
      {
        name: 'Rebound',
        adjustments: {
          'Loose on Entry': 'Decrease',
          'Tight on Entry': 'Increase',
          'Loose in Center': 'Decrease',
          'Tight in Center': 'Increase',
          'Loose on Exit': 'Increase',
          'Tight on Exit': 'Decrease',
          'Loose Overall': null,
          'Tight Overall': null
        }
      },
      {
        name: 'Camber',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': null,
          'Tight on Exit': null,
          'Loose Overall': 'More Positive',
          'Tight Overall': 'Less Positive'
        }
      }
    ]
  },
  {
    category: 'Right Rear',
    items: [
      {
        name: 'Tire Pressure',
        adjustments: {
          'Loose on Entry': 'Decrease',
          'Tight on Entry': 'Increase',
          'Loose in Center': 'Decrease',
          'Tight in Center': 'Increase',
          'Loose on Exit': 'Decrease',
          'Tight on Exit': 'Increase',
          'Loose Overall': 'Decrease',
          'Tight Overall': 'Increase'
        }
      },
      {
        name: 'Shock Collar Offset',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': null,
          'Tight on Exit': null,
          'Loose Overall': 'More Negative',
          'Tight Overall': 'More Positive'
        }
      },
      {
        name: 'Spring Rate',
        adjustments: {
          'Loose on Entry': 'Decrease',
          'Tight on Entry': 'Increase',
          'Loose in Center': 'Decrease',
          'Tight in Center': 'Increase',
          'Loose on Exit': 'Decrease',
          'Tight on Exit': 'Increase',
          'Loose Overall': 'Decrease',
          'Tight Overall': 'Increase'
        }
      },
      {
        name: 'Camber',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': null,
          'Tight on Exit': null,
          'Loose Overall': 'Less Negative',
          'Tight Overall': 'More Negative'
        }
      }
    ]
  },
  {
    category: 'Rear',
    items: [
      {
        name: 'Diff Preload',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': null,
          'Tight on Exit': null,
          'Loose Overall': 'Decrease',
          'Tight Overall': 'Increase'
        }
      },
      {
        name: 'Rear ARB: Diameter',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': null,
          'Tight on Exit': null,
          'Loose Overall': 'Decrease',
          'Tight Overall': 'Increase'
        }
      },
      {
        name: 'Rear ARB: Arm',
        adjustments: {
          'Loose on Entry': null,
          'Tight on Entry': null,
          'Loose in Center': null,
          'Tight in Center': null,
          'Loose on Exit': 'Soften',
          'Tight on Exit': 'Stiffen',
          'Loose Overall': 'Soften',
          'Tight Overall': 'Stiffen'
        }
      },
      {
        name: 'Rear Spoiler Angle',
        adjustments: {
          'Loose on Entry': 'Increase',
          'Tight on Entry': 'Decrease',
          'Loose in Center': 'Increase',
          'Tight in Center': 'Decrease',
          'Loose on Exit': 'Increase',
          'Tight on Exit': null,
          'Loose Overall': null,
          'Tight Overall': null
        }
      },
      {
        name: 'Track Bar (Right Side)',
        adjustments: {
          'Loose on Entry': 'Lower',
          'Tight on Entry': 'Higher',
          'Loose in Center': 'Lower',
          'Tight in Center': 'Higher',
          'Loose on Exit': 'Lower',
          'Tight on Exit': null,
          'Loose Overall': null,
          'Tight Overall': null
        }
      },
    ]
  }
];
export const CONDITIONS: Condition[] = [
  'Loose on Entry',
  'Tight on Entry',
  'Loose in Center',
  'Tight in Center',
  'Loose on Exit',
  'Tight on Exit',
  'Loose Overall',
  'Tight Overall'
];